/* ==== ATS PDP — externalized JS ==== */
(function () {
  'use strict';

  const SECTION_SELECTOR = '[data-section-type="ats-pdp"]';
  const CLICK_SELECTOR = '.ATS-pill, .ATS-color-swatch, .ATS-pill-below';

  function initSection(root) {
    if (!root || root.dataset.init === '1') return;
    root.dataset.init = '1';

    const productScript = root.querySelector('script[data-product-json]');
    let productData = null;
    try {
      productData = JSON.parse(productScript?.textContent || '{}');
    } catch (e) {}

    // ----- Gallery: swap hero on grid item click -----
    const mainWrap = root.querySelector('.ATS-first .ATS-main-media');
    const sources = Array.from(root.querySelectorAll('[data-media-id]'));
    function setActive(mediaId) {
      if (!mainWrap) return;
      const src = sources.find((el) => String(el.dataset.mediaId) === String(mediaId));
      if (!src) return;
      sources.forEach((el) => el.setAttribute('aria-current', 'false'));
      src.setAttribute('aria-current', 'true');
      mainWrap.innerHTML = src.innerHTML;
      mainWrap.setAttribute('data-active-media-id', mediaId);
    }
    sources.forEach((el) => el.addEventListener('click', () => setActive(el.dataset.mediaId)));

    // ----- Variant → media sync (only if data-link-media="true") -----
    if (root.getAttribute('data-link-media') === 'true' && productData && productData.media) {
      try {
        const byId = new Map(productData.media.map((m) => [String(m.id), m]));
        document.addEventListener('ats:variant:change', (ev) => {
          const v = ev.detail;
          const mediaId = v && v.featured_media && v.featured_media.id;
          if (mediaId && byId.has(String(mediaId))) setActive(mediaId);
        });
      } catch (e) {}
    }

    // ----- Qty stepper + sync to hidden input in form -----
    const qtyWrap = root.querySelector('[data-ats-qty]');
    const qtyInput = qtyWrap?.querySelector("input[name='quantity']");
    const qtyHidden = root.querySelector('input[data-qty-hidden]');
    function syncQ() {
      if (qtyHidden && qtyInput) qtyHidden.value = qtyInput.value || '1';
    }
    if (qtyWrap && qtyInput) {
      const min = Number(qtyWrap.dataset.min || 1);
      const max = Number(qtyWrap.dataset.max || 0);
      const step = Number(qtyWrap.dataset.step || 1);
      const clamp = (n) => Math.max(min, max > 0 ? Math.min(n, max) : n);
      qtyWrap.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
        qtyInput.value = clamp(parseInt(qtyInput.value || min, 10) - step);
        syncQ();
      });
      qtyWrap.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
        qtyInput.value = clamp(parseInt(qtyInput.value || min, 10) + step);
        syncQ();
      });
      ['input', 'change'].forEach((ev) => qtyInput.addEventListener(ev, syncQ));
      syncQ();
    }

    // ----- Copy link buttons -----
    root.querySelectorAll('[data-copy]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(btn.dataset.copy);
          const old = btn.textContent;
          btn.textContent = 'Copied!';
          setTimeout(() => (btn.textContent = old || 'Copy link'), 1200);
        } catch (e) {}
      });
    });

    // ----- Variant UI: options -> find variant -> set hidden id -----
    const ui = root.querySelector('[data-ats-variant-ui]');
    const formVariantInput = root.querySelector('input[data-variant-input]');
    const priceRoot = root.querySelector('[data-ats-price]');

    function norm(s) {
      return String(s || '')
        .replace(/\u00A0/g, ' ')
        .trim();
    }

    function readGroupValue(g) {
      const on = g.querySelector(`${CLICK_SELECTOR}.is-selected`);
      if (on) return on.dataset.value;
      const sel = g.querySelector('select.ATS-var__select');
      if (sel) return sel.value;
      const first = g.querySelector(CLICK_SELECTOR);
      return first ? first.dataset.value : null;
    }

    function getSelectedOptions() {
      const arr = [];
      ui?.querySelectorAll('[data-option-index]').forEach((g) => {
        const idx = parseInt(g.getAttribute('data-option-index'), 10);
        arr[idx] = readGroupValue(g);
      });
      return arr;
    }

    function findVariantByOptions(selected) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find((v) => (v.options || []).map(norm).every((opt, i) => opt === norm(selected[i])));
    }

    function updateLabels(sel) {
      sel.forEach((val, i) => {
        const el = root.querySelector(`.pdp-selected[data-label-for="${i}"]`);
        if (el && val) el.textContent = val;
      });
    }

    // ###### for sold out button and add to cart
    function updateUISelected(sel) {
      ui?.querySelectorAll('[data-option-index]').forEach((g) => {
        const idx = parseInt(g.getAttribute('data-option-index'), 10);
        const want = norm(sel[idx]);
        g.querySelectorAll(CLICK_SELECTOR).forEach((btn) => {
          btn.classList.toggle('is-selected', norm(btn.dataset.value) === want);
        });
        const selEl = g.querySelector('select.ATS-var__select');
        if (selEl && typeof sel[idx] === 'string') selEl.value = sel[idx];
      });
    }
    // ----- Money + price updater -----
    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
        // Use theme's money format if available
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }

      // Fallback formatter (INR, adjust if needed)
      return (cents / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
      });
    }

    function updatePrice(variant) {
      if (!priceRoot || !variant) return;

      // Typical Dawn structure:
      // <div class="price">
      //   <span class="price-item price-item--regular">...</span>
      //   <span class="price-item price-item--compare">...</span>
      // </div>
      const priceContainer = priceRoot.querySelector('.price') || priceRoot;

      const regularEl =
        priceContainer.querySelector('.price-item--regular') ||
        priceContainer.querySelector('.price-item--sale');

      const compareEl =
        priceContainer.querySelector('.price-item--compare') ||
        priceContainer.querySelector('.price__compare');

      if (regularEl) {
        regularEl.textContent = formatMoney(variant.price);
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          priceContainer.classList.add('price--on-sale');
        } else {
          compareEl.textContent = '';
          priceContainer.classList.remove('price--on-sale');
        }
      }
    }

    // ----- ATC state updater (sold out vs enabled) -----
    function updateATCState(variant) {
      const form = root.querySelector('product-form form');
      const atcBtn = form?.querySelector('button[data-atc]');
      const dynPayWrap = form?.querySelector('.shopify-payment-button'); // exists if dynamic checkout is on
      if (!atcBtn) return;

      // remember original label once
      if (!atcBtn.dataset.label) {
        atcBtn.dataset.label = atcBtn.textContent.trim() || 'Add to cart';
      }

      // Compute sellable condition:
      // - variant.available is Shopify's "available for sale" flag
      // - if inventory is tracked, also check inventory_quantity + policy
      const qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
      const canBackorder = variant.inventory_policy === 'continue';
      const isSellable = !!variant.available && (qty === null || qty > 0 || canBackorder);

      if (isSellable) {
        // Enable
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.classList.remove('is-sold-out');
        atcBtn.textContent = atcBtn.dataset.label;
        dynPayWrap?.classList.remove('tw-hidden');
      } else {
        // Disable
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.classList.add('is-sold-out');
        atcBtn.textContent = 'Sold out';
        dynPayWrap?.classList.add('tw-hidden');
      }
    }

    let currentVariant = null;
    function setCurrentVariant(variant) {
      if (!variant) return;
      currentVariant = variant;
      if (formVariantInput) formVariantInput.value = variant.id;
      updateLabels(variant.options || []);
      updateUISelected(variant.options || []);
      updateATCState(variant); // <— ADD THIS LINE
       updatePrice(variant);
      document.dispatchEvent(new CustomEvent('ats:variant:change', { detail: variant }));
    }

    if (ui && formVariantInput && productData) {
      // Click on pills/swatches
      ui.addEventListener('click', (e) => {
        const btn = e.target.closest(CLICK_SELECTOR);
        if (!btn) return;
        const g = btn.closest('[data-option-index]');
        const idx = parseInt(g.getAttribute('data-option-index'), 10);
        const sel = getSelectedOptions();
        sel[idx] = btn.dataset.value;
        const v = findVariantByOptions(sel);
        if (v) setCurrentVariant(v);
      });

      // Change on <select>
      ui.addEventListener('change', (e) => {
        const selEl = e.target.closest('select.ATS-var__select');
        if (!selEl) return;
        const g = selEl.closest('[data-option-index]');
        const idx = parseInt(g.getAttribute('data-option-index'), 10);
        const sel = getSelectedOptions();
        sel[idx] = selEl.value;
        const v = findVariantByOptions(sel);
        if (v) setCurrentVariant(v);
      });

      // Initial variant
      const byId = (id) => productData.variants.find((v) => String(v.id) === String(id));
      setCurrentVariant(
        byId(formVariantInput.value) || productData.variants.find((v) => v.available) || productData.variants[0]
      );
    }

    // ----- Make desktop 'Qty + Add to cart' row like Reformation -----
    const form = root.querySelector('product-form form');
    const atc = form?.querySelector('button[data-atc]');
    const qty = root.querySelector('[data-ats-qty]');
    if (form && atc && qty) {
      const row = document.createElement('div');
      row.className = 'ATS-atcRow tw-gap-3';
      atc.parentNode.insertBefore(row, atc);
      row.appendChild(qty);
      row.appendChild(atc);
    }
  }

  // Init now and on section loads (Theme Editor)
  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  // Theme Editor support (optional): re-init on Shopify section events
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();

/* ==== ATS PDP — throttle /cart/add.js ==== */

(() => {
  let t = 0,
    W = 1000,
    F = fetch;
  fetch = (...a) => {
    const u = a[0];
    if (u.includes('/cart/add.js')) {
      const n = Date.now();
      if (n - t < W) return new Response('{}', { status: 204 });
      t = n;
    }
    return F(...a);
  };
})();
